import React, { useEffect, useState } from "react";
import { Request } from "../../hooks/Request";
import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import { CustomListPDF } from "../../components/GeneratePdf/CustomListPDF";
import {
  numberWithDecimals,
  redondearPersonalizado,
  validateArray,
} from "../../utils/validate";

const s = {
  page: {
    padding: "80px 65px 0 60px",
    fontFamily: "Helvetica",
    fontSize: 11,
  },
  bold: { fontFamily: "Helvetica-Bold" },
  row: { display: "flex", flexDirection: "row", gap: 4 },
  col: { display: "flex", flexDirection: "column", gap: 4 },
  tCenter: { textAlign: "center" },
  tRight: { textAlign: "right" },
  w15: { width: "15%" },
  w70: { width: "70%" },
  w80: { width: "80%" },
  border: { borderWidth: 1 },
  header: {
    position: "absolute",
    top: 15,
    left: 5,
    zIndex: -10,
  },
  footer: {
    position: "absolute",
    bottom: 0.1,
    left: 0,
    zIndex: -10,
  },
  watterMark: {
    position: "absolute",
    zIndex: -10,
    top: "50%",
    left: "50%",
  },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
};

const listFields = [
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "a-TotalTributos",
  "b-TotalTributos",
  "c-TotalTributos",
  "porcentajeParaCalcularIva",
  "notaDeLaCotizacion",
];
export const GenerateQuotesPDF = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/dataValues?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (data) {
      setIsReady(true);
    }
  }, [data, loading]);

  const RenderCustomTable = ({
    columns,
    data,
    textTotal,
    variant = "default",
    tasaCambio = 6.96,
    gravamentGA = 0,
    ivaValue = 0,
  }) => {
    const total = data.reduce(
      (sum, item) => sum + (Number(item?.description) || 0),
      0
    );
    const { description, unit } = textTotal;

    return (
      <View>
        {variant === "iva" && (
          <>
            {redondearPersonalizado(gravamentGA) === 0 ? null : (
              <View
                style={[
                  s.row,
                  {
                    alignItems: "center",
                    justifyContent: "flex-end",
                    borderBottomWidth: 1,
                    paddingHorizontal: 5,
                    paddingTop: 6,
                  },
                ]}
              >
                <Text style={[{ width: `${columns[0].width}%` }]}>
                  Gravamen Arancelario (GA)
                </Text>
                <Text
                  style={[
                    { width: `${columns[1].width}%`, textAlign: "center" },
                  ]}
                >
                  Bs.
                </Text>
                <Text
                  style={[
                    { width: `${columns[2].width}%`, textAlign: "right" },
                  ]}
                >
                  {numberWithDecimals(redondearPersonalizado(gravamentGA))}
                </Text>
              </View>
            )}
            <View
              style={[
                s.row,
                {
                  alignItems: "center",
                  justifyContent: "flex-end",
                  borderBottomWidth: 1,
                  paddingHorizontal: 5,
                  paddingTop: 6,
                },
              ]}
            >
              <Text style={[{ width: `${columns[0].width}%` }]}>
                Impuesto al Valor Agregado (IVA)
              </Text>
              <Text
                style={[{ width: `${columns[1].width}%`, textAlign: "center" }]}
              >
                Bs.
              </Text>
              <Text
                style={[{ width: `${columns[2].width}%`, textAlign: "right" }]}
              >
                {numberWithDecimals(redondearPersonalizado(ivaValue))}
              </Text>
            </View>
          </>
        )}
        {/* Filas de datos */}
        {data.map((item, index) => (
          <View key={index} style={[s.row, { borderBottomWidth: 1 }]}>
            {columns.map((col, colIndex) => {
              let textAlignAttr = {};
              if (colIndex === 1) textAlignAttr.textAlign = "center";
              if (colIndex === 2) textAlignAttr.textAlign = "right";
              return (
                <Text
                  key={colIndex}
                  {...textAlignAttr}
                  style={{
                    width: `${col.width}%`,
                    paddingHorizontal: 5,
                    paddingTop: 6,
                    textAlign:
                      colIndex === 1
                        ? "center"
                        : colIndex === 2
                        ? "right"
                        : "left",
                  }}
                >
                  {colIndex === 2
                    ? item.currency === "$us"
                      ? numberWithDecimals(Number(item[col.name]))
                      : item.currency === "Bs."
                      ? numberWithDecimals(
                          Number(redondearPersonalizado(item[col.name]))
                        )
                      : numberWithDecimals(Number(item[col.name]))
                    : item[col.name]}
                </Text>
              );
            })}
          </View>
        ))}

        {/* Fila de totales para tabla1 */}
        {variant === "tabla1" && (
          <>
            <View
              style={[
                s.row,
                {
                  alignItems: "center",
                  justifyContent: "flex-end",
                  borderBottomWidth: 1,
                  paddingHorizontal: 5,
                  paddingTop: 6,
                },
              ]}
            >
              <Text style={[s.bold, { width: `${columns[0].width}%` }]}>
                CIF Frontera
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[1].width}%`, textAlign: "center" },
                ]}
              >
                $us
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[2].width}%`, textAlign: "right" },
                ]}
              >
                {numberWithDecimals(total)}
              </Text>
            </View>
            <View
              style={[
                s.row,
                {
                  alignItems: "center",
                  justifyContent: "flex-end",
                  borderBottomWidth: 1,
                  paddingHorizontal: 5,
                  paddingTop: 6,
                },
              ]}
            >
              <Text style={[s.bold, { width: `${columns[0].width}%` }]}>
                T/C OFICIAL
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[1].width}%`, textAlign: "center" },
                ]}
              >
                Sus/Bs
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[2].width}%`, textAlign: "right" },
                ]}
              >
                {numberWithDecimals(tasaCambio)}
              </Text>
            </View>
            <View
              style={[
                s.row,
                {
                  alignItems: "center",
                  justifyContent: "flex-end",
                  borderBottomWidth: 1,
                  backgroundColor: "#ffe080",
                  paddingHorizontal: 5,
                },
              ]}
            >
              <Text style={[s.bold, { width: `${columns[0].width}%` }]}>
                {description}
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[1].width}%`, textAlign: "center" },
                ]}
              >
                {unit}
              </Text>
              <Text
                style={[
                  s.bold,
                  { width: `${columns[2].width}%`, textAlign: "right" },
                ]}
              >
                {numberWithDecimals(redondearPersonalizado(tasaCambio * total))}
              </Text>
            </View>
          </>
        )}

        {/* Fila del total */}
        {variant === "default" && (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              borderBottomWidth: 1,
              backgroundColor: "#ffe080",
              paddingHorizontal: 5,
            }}
          >
            <Text style={[s.bold, { width: `${columns[0].width}%` }]}>
              {description}
            </Text>
            <Text
              style={[
                s.bold,
                { width: `${columns[1].width}%`, textAlign: "center" },
              ]}
            >
              {unit}
            </Text>
            <Text
              style={[
                s.bold,
                { width: `${columns[2].width}%`, textAlign: "right" },
              ]}
            >
              {numberWithDecimals(total)}
            </Text>
          </View>
        )}

        {/* Fila de totales para tabla1 */}
        {variant === "iva" && (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              borderBottomWidth: 1,
              backgroundColor: "#ffe080",
              paddingHorizontal: 5,
            }}
          >
            <Text style={[s.bold, { width: `${columns[0].width}%` }]}>
              {description}
            </Text>
            <Text
              style={[
                s.bold,
                { width: `${columns[1].width}%`, textAlign: "center" },
              ]}
            >
              {unit}
            </Text>
            <Text
              style={[
                s.bold,
                { width: `${columns[2].width}%`, textAlign: "right" },
              ]}
            >
              {numberWithDecimals(total + Number(ivaValue) + gravamentGA)}
            </Text>
          </View>
        )}
      </View>
    );
  };

  const MyDoc = ({ data }) => {
    // cambiar el la marca de agua y otros aqui
    const tasaCambio =
      (data.valoresNominalesSubDatas &&
        data.valoresNominalesSubDatas.find(
          (item) => item.label === "T/C OFICIAL"
        )?.description) ||
      6.96;
    const totalNominales =
      data.valoresNominalesSubDatas &&
      data.valoresNominalesSubDatas
        .filter((item) => item.label !== "T/C OFICIAL")
        .reduce((sum, item) => sum + Number(item.description), 0) * tasaCambio;

    const gravamentGA = Number(
      redondearPersonalizado(
        totalNominales * (Number(data.porcentajeParaCalcularIva) / 100)
      )
    );
    const baseImp =
      Number(redondearPersonalizado(totalNominales)) +
      Number(redondearPersonalizado(gravamentGA));
    const ivaValue = Number(
      redondearPersonalizado(
        Number(redondearPersonalizado(baseImp)) * (Number(14.94) / 100)
      )
    );
    const totalA = Number(
      redondearPersonalizado(
        data &&
          data["a-TotalTributosSubDatas"] &&
          validateArray(data["a-TotalTributosSubDatas"])
          ? data["a-TotalTributosSubDatas"].reduce(
              (sum, item) => sum + Number(item.description),
              0
            ) +
              gravamentGA +
              ivaValue +
              100
          : gravamentGA + ivaValue + 100
      )
    );
    const totalB = Number(
      redondearPersonalizado(
        data &&
          data["b-TotalTributosSubDatas"] &&
          validateArray(data["b-TotalTributosSubDatas"])
          ? data["b-TotalTributosSubDatas"].reduce(
              (sum, item) =>
                sum + Number(redondearPersonalizado(item.description)),
              0
            )
          : 0
      )
    );
    const totalC = Number(
      redondearPersonalizado(
        data &&
          data["c-TotalTributosSubDatas"] &&
          validateArray(data["c-TotalTributosSubDatas"])
          ? data["c-TotalTributosSubDatas"].reduce(
              (sum, item) => sum + Number(item.description),
              0
            )
          : 0
      )
    );

    return (
      <Document>
        <Page size="LETTER" style={[s.page, { paddingTop: "60px" }]}>
          {/* FORMATO */}
          <View style={s.styleFormat}>
            <Image
              src="https://res.cloudinary.com/joeldes/image/upload/v1751556894/DeliveryDay/reports/DD_formato-informe_xdmzwo.jpg"
              style={{ width: "100%", height: "100%" }}
            />
          </View>

          {/* Titulo y fecha */}
          <View style={[s.bold, s.col, { paddingBottom: 0 }]}>
            <Text
              style={[
                {
                  textAlign: "center",
                  fontSize: 12,
                },
              ]}
            >
              COTIZACION PROFORMA N° {data.nroCotizacion} DELIVERYDAY
            </Text>
            <Text style={[{ textAlign: "right", fontSize: 9 }]}>
              {dayjs().format("DD/MM/YYYY")}
            </Text>
          </View>

          {/* Cabecera --> Informacion General */}
          <View style={[s.col, s.bold, { paddingBottom: 5 }]}>
            <View style={[s.row]}>
              <Text style={{ flex: 1, textAlign: "right" }}>Señores:</Text>
              <Text style={{ width: "80%" }}>{data.company.razonSocial}</Text>
            </View>
            <View style={[s.row]}>
              <View style={[s.col, { flex: 1, gap: 2, textAlign: "right" }]}>
                <Text style={{ flex: 1 }}>Modalidad de transporte:</Text>
              </View>
              <View style={[s.col, { gap: 2, width: "80%" }]}>
                <Text> </Text>
                <Text>{data.modalidadDeDespacho}</Text>
              </View>
            </View>
          </View>

          {/* Tasa de cambio y demas */}
          <View
            style={[
              s.row,
              { gap: 10, paddingBottom: 15, alignItems: "center" },
            ]}
          >
            <View
              style={[
                s.col,
                s.bold,
                { width: "50%", textAlign: "right", gap: 1, fontSize: 9 },
              ]}
            >
              <Text>Valores nominales para</Text>
              <Text>determinar pagos aduanerios</Text>
              <Text>segun Art. 20</Text>
              <Text>D.S. 25870</Text>
            </View>
            <View style={[s.col, { width: "50%", gap: 10, fontSize: 9 }]}>
              <View
                style={[
                  s.row,
                  {
                    borderWidth: 1,
                    paddingTop: 7,
                    justifyContent: "space-around",
                  },
                ]}
              >
                <Text>T/C DOLAR</Text>
                <Text>{tasaCambio}</Text>
              </View>
              {data.valoresNominalesSubDatas && (
                <RenderCustomTable
                  variant="tabla1"
                  columns={[
                    {
                      label: "Pagos",
                      name: "label",
                      width: "55",
                    },
                    {
                      label: "Moneda",
                      name: "currency",
                      width: "20",
                    },
                    {
                      label: "Monto",
                      name: "description",
                      width: "25",
                    },
                  ]}
                  textTotal={{
                    description: "Total CIF Frontera BASE DE LIQUIDACION",
                    unit: "Bs.",
                  }}
                  data={data.valoresNominalesSubDatas
                    .map((item) => {
                      return {
                        ...item,
                        currency: "$us",
                        description: item.description,
                      };
                    })
                    .filter((item) => item.label !== "T/C OFICIAL")}
                />
              )}
            </View>
          </View>

          {/* Descripcion */}
          <View style={[s.col, { gap: 0, lineHeight: 1.2, paddingBottom: 15 }]}>
            <Text>
              Mediante la presente, liquidacion Proforma, internacion de
              mercancia
            </Text>
            <Text>
              {data.descripciónDeLaMercancía} a pais Boliviano con elsiguiente
              detalle:
            </Text>
            <Text>
              <Text style={s.bold}>PARTIDA ARANCELARIA:</Text>{" "}
              {data.partidaArancelaria}
            </Text>
          </View>

          {/* Totales */}
          <View
            style={[
              s.col,
              { gap: 8, alignItems: "flex-end", paddingBottom: 15 },
            ]}
          >
            <View style={{ width: "80%" }}>
              <RenderCustomTable
                variant="iva"
                columns={[
                  {
                    label: "Pagos",
                    name: "label",
                    width: "70",
                  },
                  {
                    label: "Moneda",
                    name: "currency",
                    width: "15",
                  },
                  {
                    label: "Monto",
                    name: "description",
                    width: "15",
                  },
                ]}
                textTotal={{
                  description: "TOTAL TRIBUTOS (A)",
                  unit: "Bs.",
                }}
                data={
                  data &&
                  data["a-TotalTributosSubDatas"] &&
                  validateArray(data["a-TotalTributosSubDatas"])
                    ? [
                        ...data["a-TotalTributosSubDatas"].map((item) => ({
                          ...item,
                          description: Number(
                            redondearPersonalizado(item.description)
                          ),
                          currency: "Bs.",
                        })),
                        {
                          label: "Pago DIM - Sistema SUMA",
                          currency: "Bs.",
                          description: "100",
                          description2: "100",
                        },
                      ]
                    : [
                        {
                          label: "Pago DIM - Sistema SUMA",
                          currency: "Bs.",
                          description: "100",
                          description2: "100",
                        },
                      ]
                }
                gravamentGA={gravamentGA}
                ivaValue={ivaValue}
              />
            </View>
            <View style={{ width: "80%" }}>
              {data["b-TotalTributosSubDatas"] && (
                <RenderCustomTable
                  columns={[
                    {
                      label: "Pagos",
                      name: "label",
                      width: "70",
                    },
                    {
                      label: "Moneda",
                      name: "currency",
                      width: "15",
                    },
                    {
                      label: "Monto",
                      name: "description",
                      width: "15",
                    },
                  ]}
                  textTotal={{
                    description: "SubTotal (B)",
                    unit: "Bs.",
                  }}
                  data={data["b-TotalTributosSubDatas"]?.map((item) => ({
                    ...item,
                    description: Number(
                      redondearPersonalizado(item.description)
                    ),
                    currency: "Bs.",
                  }))}
                />
              )}
            </View>
            <View style={{ width: "80%" }}>
              {data["c-TotalTributosSubDatas"] && (
                <RenderCustomTable
                  columns={[
                    {
                      label: "Pagos",
                      name: "label",
                      width: "70",
                    },
                    {
                      label: "Moneda",
                      name: "currency",
                      width: "15",
                    },
                    {
                      label: "Monto",
                      name: "description",
                      width: "15",
                    },
                  ]}
                  textTotal={{
                    description: "Sub Total (C)",
                    unit: "Bs.",
                  }}
                  data={data["c-TotalTributosSubDatas"]?.map((item) => ({
                    ...item,
                    description: Number(
                      redondearPersonalizado(item.description)
                    ),
                    currency: "Bs.",
                  }))}
                />
              )}
            </View>
            <View style={[s.col, { gap: 0 }]}>
              <View
                style={[
                  s.row,
                  s.w80,
                  s.border,
                  { gap: 0, backgroundColor: "#ffe080", padding: "1px" },
                ]}
              >
                <Text style={s.w70}>
                  TOTAL NACIONALIZACIÓN BOLIVIANOS (A,B,C)
                </Text>
                <Text style={[s.w15, s.tCenter]}>Bs.</Text>
                <Text style={[s.w15, s.tRight]}>
                  {numberWithDecimals(Number(totalA + totalB + totalC))}
                </Text>
              </View>
              <View
                style={[s.row, s.w80, s.border, { gap: 0, padding: "1px" }]}
              >
                <Text style={s.w70}>TOTAL NACIONALIZACIÓN DOLARES (A,B,C)</Text>
                <Text style={[s.w15, s.tCenter]}>USD</Text>
                <Text style={[s.w15, s.tRight]}>
                  {((totalA + totalB + totalC) / tasaCambio).toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ paddingTop: 0, fontSize: 10 }}>
            <Text>
              La presente cotización está sujeta a variaciones del tipo de
              cambio según el Banco Central de Bolivia.
            </Text>
            <Text>Nota: {data.notaDeLaCotizacion}</Text>
          </View>
        </Page>

        <Page size="LETTER" style={[s.page, { padding: "80px 85px 0 60px" }]}>
          {/* FORMATO */}
          <View
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: -10,
              width: "612px",
              height: "792px",
            }}
          >
            <Image
              src="https://res.cloudinary.com/joeldes/image/upload/v1751556894/DeliveryDay/reports/DD_formato-informe_xdmzwo.jpg"
              style={{ width: "100%", height: "100%" }}
            />
          </View>

          {/* Titulo del documento */}
          <View style={[s.bold, { paddingBottom: 15 }]}>
            <Text style={[{ textAlign: "center", fontSize: 12 }]}>
              CONDICIONES GENERALES
            </Text>
          </View>

          {/* REFACTORIZADO --> Seccion de Articulos */}
          <View style={[s.col, { gap: 6, paddingBottom: 15 }]}>
            <Text style={[s.bold, { textAlign: "left", fontSize: 10 }]}>
              BASE LEGAL
            </Text>
            <CustomListPDF
              items={[
                {
                  bullet: "•",
                  text: `**Art.42** del Capitulo III de la Ley General de Aduanas N° 1990 define el Despachante de Aduana como la persona natural y profesional auxiliar de la función pública aduanera autorizada por Aduana Nacional para realizar gestiones inherentes a operaciones de comercio exterior por cuenta de terceros.`,
                },
                {
                  bullet: "•",
                  text: `**Art.46** del Capítulo III de la Ley General de Aduanas Nº 1990 define que el Despachante de Aduana y la Agencia Despachante de Aduana realiza su labor bajo el principio de buena fe y presunción de veracidad por cuenta del comitente o consignatario de las mercancías.`,
                },
                {
                  bullet: "•",
                  text: `**Art.51** del Capítulo III de la Ley General de Aduanas Nº 1990 cita que la Agencia Despachante de Aduana mediante su representante legal el Despachante de Aduana podrá constituirse y apelar al cumplimiento de las normas vigentes bajo cualquiera de las formas jurídicas reconocidas por el Código de Comercio.`,
                },
                {
                  bullet: "•",
                  text: `**Art.111** del Reglamento a la Ley General de Aduanas D.S. 25870 estipula la documentación necesaria con carácter obligatorio para realizar la declaración de mercancías que  corresponda, mismas que serán puestas a disposición y revisión de la Administración Aduanera de turno. Art. 20 del reglamento a la Ley General de Aduanas D.S. 25870 estipula el criterio por el cual se determina la base imponible sobre la cual se realizará el pago correspondiente de tributación aduanera.`,
                },
              ]}
            />
          </View>

          {/* REFACTORIZADO --> Seccion Base contractual */}
          <View style={[s.col, { gap: 6, paddingBottom: 15 }]}>
            <Text style={[s.bold, { textAlign: "left", fontSize: 10 }]}>
              BASE CONTRACTUAL
            </Text>
            <CustomListPDF
              items={[
                {
                  bullet: "•",
                  text: `El presente documento es emitido conforme solicitud del comitente o consignatario a partir de la presentación de documentación soporte suficiente para determinar lo estipulado según Art. 20 del Reglamento a la Ley General de Aduanas D.S. 25870.`,
                },
                {
                  bullet: "•",
                  text: `La validez del presente documento tiene una duración de 30 días calendario a partir de la fecha de emisión siempre y cuando los valores finales de la documentación soporte no sufran ningún cambio en relación a la cotización de monedas vigente emitida por el Banco Central de Bolivia y exigida por Aduana Nacional.`,
                },
                {
                  bullet: "•",
                  text: `La presente cotización en ninguno de los casos ampara transporte de mercadería antes y después de las gestiones dentro del Recinto Aduanero de turno, siendo esta responsabilidad exclusiva del comitente, consignatario y/o agente de carga contratado directamente por el comitente o consignatario.`,
                },
                {
                  bullet: "•",
                  text: `El presente documento queda sujeto a modificación sin previo aviso por parte de Agencia Despachante de Aduana DELIVERYDAY SRL estableciendo que los valores que cite el mismo son temporales y/o aproximados.`,
                },
                {
                  bullet: "•",
                  text: `A la aceptación del presente documento el comitente o consignatario se sujeta a las condiciones antes estipuladas.`,
                },
                {
                  bullet: "•",
                  text: `El valor final del presente documento debe ser cancelado a las siguientes cuentas habilitadas para nuestro acreditado Legal con poder: 0538/2019`,
                },
              ]}
            />
          </View>

          {/* REFACTORIZADO Lista Info. General */}
          <View style={[s.col, { gap: 2, paddingLeft: 15 }]}>
            <CustomListPDF
              items={[
                {
                  bullet: "–",
                  text: `WILSON CANDIA ESPEJO cuenta bancaria en moneda nacional del Banco UNION cta. Nro. 10000017356309. En caso de pago mediante cheque emitirlo a nombre de Wilson Candía Espejo.    Swift: BAUNBO22LPZ`,
                },
                {
                  bullet: "–",
                  text: `WILSON CANDIA ESPEJO cuenta bancaria en moneda extranjera (USD) del Banco BISA cta. Nro. 318666-501-4         Swift: BANIBOLXXXX `,
                },
                {
                  bullet: "–",
                  text: `Enviar recibo escaneado a los correos una vez realizado el depósito.`,
                },
              ]}
            />
          </View>
        </Page>
      </Document>
    );
  };

  if (!isReady) {
    return null;
  }

  return (
    <div>
      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDoc data={data} />
        </PDFViewer>
      )}
    </div>
  );
};
